import cx from "classnames";
import React from "react";

interface StickerProps {
  color?: "black" | "orange";
  size?: "small";
  children?: React.ReactNode;
  className?: string;
  [key: string]: any;
}

const CLASS_ROOT = "sticker";

export const Sticker: React.FC<StickerProps> = ({
  color,
  size,
  children,
  className,
  ...other
}) => {
  const classes = cx(
    CLASS_ROOT,
    {
      [`${CLASS_ROOT}--${color}`]: color,
      [`${CLASS_ROOT}--${size}`]: size,
    },
    className,
  );

  return (
    <div className={classes} {...other}>
      {children}
    </div>
  );
};

Sticker.displayName = "Sticker";
